module.exports = __webpack_public_path__ + "static/media/confirmation-check.da8ce823.svg";